// 20250719: xt/chtg converted the react-bootstrap to only bootstrap 5.3.3 
//         this way we can remove/uninstall react-bootstrap completely
import React from 'react'
import { connect } from 'react-redux'
import { hideModal, updateModalProps } from '../../actions/modal'
import { postDepartmentIncidentAssignment } from '../../actions/reportSummaries'
//import { Modal, ListGroup, ListGroupItem, FormGroup, FormControl, InputGroup } from 'react-bootstrap'

const SelectDepartmentModal = ({
  agency,
  incident,
  reportSchemaId,
  departments,
  dispatch,
  visible,
  languageCode
}) => {
  const departmentsMaster = agency.assignees.departments
  const hide = () => dispatch(hideModal())
  const saveSelection = (assignmentId) => {
    if (!incident.assignments[0] || assignmentId !== incident.assignments[0].assignee.department_id) {
      dispatch(postDepartmentIncidentAssignment(incident, agency._id, reportSchemaId, assignmentId))
    }
    dispatch(hideModal())
  }

  const filterList = (event) => {
    var updatedList = departmentsMaster
    updatedList = updatedList.filter((item) => {
      return item.name[languageCode].toLowerCase().search(
        event.target.value.toLowerCase()) !== -1
    })

    dispatch(updateModalProps('departments', updatedList))
  }

  // return (
  //   <Modal show={visible} onHide={hide} id='department-modal' dialogClassName='assignment-modal' backdrop>
  //     <Modal.Header closeButton>
  //       <Modal.Title>Select Department</Modal.Title>
  //     </Modal.Header>
  //     <Modal.Body>

  //       <FormGroup>
  //         <InputGroup id='department-search-input'>
  //          <InputGroup>
  //           <FormControl placeholder="Search" />
  //           <InputGroup.Text>
  //            <span className="material-icons">search</span>
  //           </InputGroup.Text>
  //          </InputGroup>
  //           <FormControl id='department-search' type='text' placeholder='Search' onChange={filterList} />
  //         </InputGroup>
  //       </FormGroup>
        
  //       <ListGroup className='text-medium'>
  //         {departments.map(department =>
  //           <ListGroupItem key={department._id} onClick={() => saveSelection(department._id)}>
  //             <svg height='40px' width='40px'>
  //               <circle cx='20' cy='20' r='18' style={{fill: department.color}} />
  //             </svg>
  //             <div className='department-name'>{department.name[languageCode]}</div>
  //           </ListGroupItem>
  //         )}
  //       </ListGroup>
  //     </Modal.Body>
  //   </Modal>
  // )



  return (
  visible && (
    <>
      <div
        className="modal fade show d-block"
        id="department-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog assignment-modal" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Select Department</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={hide}
              ></button>
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <div id="department-search-input" className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <span className="input-group-text">
                    <span className="material-icons">search</span>
                  </span>
                </div>

                <input
                  id="department-search"
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={filterList}
                />
              </div>

              <ul className="list-group text-medium">
                {departments.map((department) => (
                  <li
                    key={department._id}
                    className="list-group-item d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => saveSelection(department._id)}
                  >
                    <svg height="40px" width="40px" className="me-3">
                      <circle
                        cx="20"
                        cy="20"
                        r="18"
                        style={{ fill: department.color }}
                      />
                    </svg>
                    <div className="department-name">
                      {department.name[languageCode]}
                    </div>
                  </li>
                ))}
              </ul>

            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  )
);

}

export default connect()(SelectDepartmentModal)
